import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { setSelectedElementUuidsAction } from 'editor/src/store/editor/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import addSelectedMediaElementOperation from './addSelectedMediaElementOperation';
import setFocusedMediaElementUuidOperation from './setFocusedMediaElementUuidOperation';

const addSelectedMediaElementsOperation = (uuids: number[]) => (dispatch: ThunkDispatch, getState: () => RootState) => {
  const state = getState();
  const uniqueUids = [...new Set(uuids)];
  if (uniqueUids.length === 1) {
    dispatch(addSelectedMediaElementOperation(uniqueUids[0]));
    return;
  }

  if ([...state.editor.selectedElementUuids].sort().join(',') === [...uniqueUids].sort().join(',')) {
    return;
  }

  batch(() => {
    dispatch(setFocusedMediaElementUuidOperation(undefined));
    dispatch(setSelectedElementUuidsAction(uniqueUids));
    // TODO Switch tab
  });
};

export default addSelectedMediaElementsOperation;
